module.exports = __webpack_public_path__ + "img/457088ca24bf71c9c9c44f33f532b914.jpg";